import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Lakeland, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Lakeland, Florida. Serving Polk County, Central Florida, and the I-4 corridor. As fast as 24 hours — no 4-hour drive to Miami needed.";

const areaServedList = [
  { "@type": "City", name: "Lakeland" },
  { "@type": "City", name: "Winter Haven" },
  { "@type": "City", name: "Auburndale" },
  { "@type": "City", name: "Bartow" },
  { "@type": "City", name: "Plant City" },
  { "@type": "City", name: "Kathleen" },
  { "@type": "City", name: "Mulberry" },
  { "@type": "AdministrativeArea", name: "Polk County" },
];

const lakelandFaqs = [
  { q: "How do I get an expedited passport in Lakeland, Florida?", a: "Lakeland residents can use Fast Passport Center for 2–9 day expedited processing. Start online, ship documents overnight, and we handle agency submission remotely. The nearest regional agency is in Miami, 280 miles away via I-4 and I-75." },
  { q: "Where is the nearest passport agency to Lakeland?", a: "The Miami Passport Agency (1501 Biscayne Blvd Suite 210, Miami, FL 33132) is approximately 280 miles southeast of Lakeland via I-4 and I-75. It requires an appointment for emergencies only. Fast Passport Center eliminates that 8-hour round trip entirely." },
];

export default function LakelandPage() {
  return (
    <>
      <CitySEOHead
        city="Lakeland"
        state="Florida"
        stateAbbr="FL"
        route="/cities/lakeland"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Lakeland, Florida"
        geoPosition="28.0395;-81.9498"
        keywords="expedited passport Lakeland, emergency passport Lakeland FL, same day passport Lakeland, fast passport Polk County, passport renewal Lakeland, Central Florida passport courier"
        faqs={lakelandFaqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Lakeland travelers with immediate departure needs — as fast as 24 hours for Polk County residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Lakeland with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Lakeland and Central Florida families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Lakeland, FL." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Polk County families." },
          { name: "Name Change", description: "Passport correction and name change service for Lakeland residents after marriage or legal changes." },
          { name: "Damaged Passport", description: "Damaged passport replacement service for Lakeland and I-4 corridor residents." },
        ]}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-07-15"
        areaServedList={areaServedList}
        serviceAreaDesc="Expedited and emergency passport services for Lakeland, FL and Polk County. As fast as 24 hours. No 4-hour drive to Miami needed."
      />

      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
      </div>
    </>
  );
}